import { Model, Types } from '~app/core/model';
import Position from './Position';

const DiagramSignal = Model.createType({
  name: 'DiagramSignal',
  fields: {
    polarity: Types.STR(), // polarity of the connectors (+,-,0)
    connectFrom: Types.STR(), // stores an object name
    connectTo: Types.STR(), // stores an object name
    connectionHint: Types.STR(),
    polarityHint: Types.STR(),
    position: Types.MODEL(Position), // {x, y}
    hasError: Types.TRANSIENT(),
  },
});

const validators = [
  obj =>
    obj.polarity === '+' || obj.polarity === '-' || obj.polarity === '0'
      ? [true]
      : [false, 'invalid-signal-polarity-value', { value: obj.polarity }],
  obj =>
    obj.connectFrom
      ? [true]
      : [false, 'missing-or-empty-key', { key: 'connectFrom' }],
  obj =>
    obj.connectTo
      ? [true]
      : [false, 'missing-or-empty-key', { key: 'connectTo' }],
  obj => (obj.connectTo !== obj.connectFrom ? [true] : [false, 'same-from-to']),
  (obj, sfm) =>
    sfm.labelsAsSet.has(obj.connectFrom)
      ? [true]
      : [false, 'no-such-label', { label: obj.connectFrom }],
  (obj, sfm) =>
    sfm.labelsAsSet.has(obj.connectTo)
      ? [true]
      : [false, 'no-such-label', { label: obj.connectTo }],
];

DiagramSignal.prototype.getIsValid = function (sfm) {
  for (const v of validators) {
    const [result, ...err] = v(this, sfm);
    if (!result) {
      return [result, ...err];
    }
  }
  return [true];
};

export default DiagramSignal;
